import React from 'react';
import { EMOJIS } from '../utils/utils';

const ReactionBox = ({
    position,
    isFromCurrentUser,
    message,
    currentUserId,
    onReact,
    onReply,
    onEdit,
    onDelete,
    onClose,
    boxRef,
    isHost = false,
    showReply = true,
    type = "private", // "private" or "group"
}) => {
    const isOwnMessage = message.senderId === currentUserId;

    return (
        <div
            ref={boxRef}
            onTouchStart={(e) => e.stopPropagation()}
            onTouchEnd={(e) => e.stopPropagation()}
            onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
            style={{
                position: "fixed",
                top: position.y - 10,
                left: Math.min(
                    window.innerWidth - (isFromCurrentUser ? 100 : 0),
                    Math.max(100, position.x)
                ),
                transform: "translate(-50%, -100%)",
                zIndex: 9999,
            }}
            className="bg-white dark:bg-gray-800 rounded-xl shadow-lg px-3 py-2 border border-gray-200 dark:border-gray-700"
        >
            {/* Emoji row */}
            <div className={`flex space-x-2  ${type === "community" && !isFromCurrentUser ? "" : "border-b pb-2 mb-2"}  border-gray-200 dark:border-gray-700`}>
                {EMOJIS.map((emoji) => (
                    <button
                        key={emoji.id}
                        onClick={() => {
                            onReact(message.id, emoji);
                            onClose();
                        }}
                        className="text-2xl hover:scale-125 transition transform duration-150"
                    >
                        {emoji.char}
                    </button>
                ))}
            </div>

            {/* Action buttons */}
            <div className="flex flex-col space-y-1">
                {showReply && (
                    <button
                        onClick={() => {
                            onReply(message);
                            onClose();
                        }}
                        className="flex items-center space-x-2 px-2 py-1.5 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg w-full text-left"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
                        </svg>
                        <span>Reply</span>
                    </button>
                )}

                {/* Edit option - only for own text messages */}
                {(isOwnMessage || (isHost && message.senderId !== currentUserId)) && message.text && (
                    <button
                        onClick={() => {
                            onEdit(message);
                            onClose();
                        }}
                        className="flex items-center space-x-2 px-2 py-1.5 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg w-full text-left"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                        <span>Edit</span>
                    </button>
                )}

                {/* Delete option */}
                {(isOwnMessage || isHost) && (
                    <button
                        onClick={() => {
                            onDelete(message.id);
                            onClose();
                        }}
                        className="flex items-center space-x-2 px-2 py-1.5 text-sm text-red-600 dark:text-red-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg w-full text-left"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                        <span>Delete</span>
                    </button>
                )}
            </div>
        </div>
    );
};

export default ReactionBox;